import { getApiClient } from '@apps/web/lib/api_client';

export async function claimSlackWebCollaborationDeepLink({
    chatId,
    organizationId,
    slackWebClaim,
}: {
    readonly chatId: string;
    readonly organizationId: string | null;
    readonly slackWebClaim: string | null;
}): Promise<boolean> {
    if (!slackWebClaim) {
        return true;
    }
    if (!organizationId) {
        return false;
    }

    try {
        await getApiClient().post({
            url: '/organizations/{organization_id}/runs/{run_id}/slack-collaboration-claim',
            pathParams: {
                organization_id: organizationId,
                run_id: chatId,
            },
            body: { token: slackWebClaim },
        });
    } catch {
        return false;
    }
    return true;
}
